var referApplicationModule = angular.module('referApplicationModule', []);
/******************** Controllers ****************************/

// Application controller
referApplicationModule.controller('RefAppCtrl', ['$scope', '$rootScope', 'refAppService',
    function ($scope, $rootScope, refAppService) {
        $scope.flags.showGridLoader = true;
        //$scope.hideContent = true;
        refAppService.getRefApps();
    }
]);

// Filter controller
referApplicationModule.controller('RefAppFilterCtrl', ['$scope', 'closeFilter', 'openFilter', '$rootScope', 'refAppService',
    function ($scope, closeFilter, openFilter, $rootScope, refAppService) {
        var todaysDate = new Date();
        $scope.actionTypeOptions = [{
            id: 'HIRED',
            text: i18n['JV_JOBVITE_HIRED']
        }];

        $scope.filterObject = {};
        $scope.filterObject.actionType = '';
        $scope.checkIfApply = false;

        $scope.makeCall = true;
        $scope.closeFilter = function () {
            closeFilter();
        };
        $scope.openFilter = function () {
            openFilter();
        };

        $scope.reset = function () {
            $scope.filterObject = {};
            $scope.filterObject.actionType = '';
        };

        function checkToMakeCall() {
            if (new Date($scope.filterObject.startDate) > new Date($scope.filterObject.endDate)) {
                $scope.makeCall = false;
                $('.jv-dateError').removeClass('jv-hide');
            } else {
                $('.jv-dateError').addClass('jv-hide');
                $scope.makeCall = true;
            }
        }


        $scope.$watch('filterObject', function (newValue, oldValue) {
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            checkToMakeCall();

            if ($scope.makeCall === true) {
                var _args = angular.copy($scope.filterObject);
                if ($scope.filterObject.startDate && $scope.filterObject.startDate.trim() !== '' && $scope.filterObject.endDate && $scope.filterObject.endDate.trim() !== '') {
                    _args.startDate = $scope.filterObject.startDate;
                    _args.endDate = $scope.filterObject.endDate;
                }
                callSetFilters(_args);
            }
        }, true);

        function callSetFilters(_args) {
            if ($scope.filterObject.startDate && $scope.filterObject.startDate.trim() !== '') {
                _args.startDate = $scope.filterObject.startDate;
            }
            if ($scope.filterObject.endDate && $scope.filterObject.endDate.trim() !== '') {
                _args.endDate = $scope.filterObject.endDate;
            }
            refAppService.setFilters(_args);
        }

    }
]);

// Header controller
referApplicationModule.controller('RefAppHeaderCtrl', ['$scope', 'refAppService',
    function RefAppHeaderCtrl($scope, refAppService) {
        $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
        $scope.page = -1;



        $scope.$on('messageResults', function (event, results) {
            $scope.selection = {};
        });

        $scope.$on('updatePage', function () {
            $scope.page = refAppService.page;
        });

        function updatePaginationVars() {
            if ($scope.total !== 0) {
                $scope.start = ($scope.page * $scope.pageCount) + 1;
                $scope.end = ($scope.totalPages === $scope.page) ? $scope.total : ($scope.page * $scope.pageCount) + $scope.pageCount;
            } else {
                // total count is zero
                $scope.start = 0;
                $scope.end = 0;
            }
        }

        $scope.$on('paginationBroadcast', function () {
            $scope.total = refAppService.total;
            $scope.pageCount = refAppService.pageCount;
            $scope.totalPages = Math.ceil($scope.total / $scope.pageCount) - 1;
            $scope.page = refAppService.page;
            updatePaginationVars();
        });

        $scope.paginate = function (next) {
            next = !!next;
            // check if there is no next/previous page.
            if (($scope.total === $scope.end && next) || ($scope.page === 0 && !next)) {
                return;
            }
            refAppService.setPage(next ? $scope.page + 1 : $scope.page - 1);
        };
    }
]);

// Grid controller
referApplicationModule.controller('RefAppGridCtrl', ['$scope', '$rootScope', 'refAppService',
    function ($scope, $rootScope, refAppService) {
        var _result = null;
        $scope.refApps = [];
        $scope.resultExists = false;
        $scope.flags.showGridLoader = true;

        $scope.showComment = function (text, action, EId, index) {
            if (action === i18n['COMMON_ADD']) {
                $rootScope.$broadcast('openAddCommentModal', '', EId, index);
            }
            if (action === i18n['COMMON_VIEW']) {
                $rootScope.$broadcast('openViewCommentModal', text, EId, index);
            }
        };

        $scope.$on('hideProceesing', function () {
            $scope.flags.showGridLoader = false;
        });

        $scope.$on('setToView', function (event, comment, index) {
            $scope.refApps[index].comments = i18n['COMMON_VIEW'];
            $scope.refApps[index].commentText = comment;
        });

        $scope.$on('updateMessages', function (event, page) {
            $scope.flags.showGridLoader = true;
            getUpdatedApps();
        });

        function getUpdatedApps() {
            refAppService.getRefApps();
        }

        function updateTheApps(results) {
            var _backupResults = [];
            $scope.resultExists = 'null';
            $scope.resultExists = false;
            $scope.refApps = [];

            refAppService.setPaginationVariables({
                total: parseInt((!!results.resultCount ? results.resultCount : 0)),
                pageCount: parseInt((!!results.pageCount ? results.pageCount : 10)),
                page: parseInt((!!results.page ? results.page : 0))
            });
            if (typeof results.resultList !== 'undefined' && results.resultList != null && results.resultList.length) {
                _backupResults = results.resultList;
                for (var i = 0, j = _backupResults.length; i < j; i++) {
                    $scope.refApps[i] = results.resultList[i];
                    $scope.refApps[i].showReqId = results.resultList[i].allApplications[0].requisitionId && !(results.resultList[i].allApplications[0].requisitionId.trim() !== '');
                    $scope.refApps[i].appEId = results.resultList[i].allApplications[0].EId;
                    $scope.refApps[i].jobviteMessageEId = (results.resultList[i].jobviteMessageEId && results.resultList[i].jobviteMessageEId.trim() !== '') ? i18n['JV_JOBVITE'] : i18n['JV_REFERRED'];
                    $scope.refApps[i].jobTitle = results.resultList[i].allApplications[0].jobTitle;
                    $scope.refApps[i].requisitionId = results.resultList[i].allApplications[0].requisitionId;
                    $scope.refApps[i].status = results.resultList[i].allApplications[0].applicationStatusLabel;
                    $scope.refApps[i].dateSent = results.resultList[i].allApplications[0].sentDate;
                    $scope.refApps[i].id = i;
                    if (results.resultList[i].allApplications[0].comments && results.resultList[i].allApplications[0].comments.trim() !== '') {
                        $scope.refApps[i].comments = i18n['COMMON_VIEW'];
                        $scope.refApps[i].commentText = results.resultList[i].allApplications[0].comments;
                    } else {
                        $scope.refApps[i].comments = i18n['COMMON_ADD'];
                        $scope.refApps[i].commentText = '';
                    }
                    $scope.resultExists = true;
                }
            }
            $scope.flags.showGridLoader = false;
        }

        $scope.$on('messageResults', function (event, results) {
            _result = results;
            updateTheApps(_result);
        });
    }
]);

referApplicationModule.controller('RefAppModalController', ['$scope', '$rootScope', 'refAppService',
    function ($scope, $rootScope, refAppService) {
        $scope.showError = false;

        $scope.$on('setComment', function (event, text, EId, index) {
            $scope.showError = false;
            $scope.comment = text;
            $scope.EId = EId;
            $scope.id = index;
        });

        $scope.comment = '';

        $scope.$watch('comment', function () {});

        $scope.$on('COMMENT_HIDING_MODAL', function (event) {

        });

        $scope.save = function () {
            if ($scope.comment === '') {
                $scope.showError = true;
            } else {
                $scope.showError = false;
                var args = {
                    comment: $scope.comment,
                    EId: $scope.EId
                };
                refAppService.addComment(args, function (result) {
                    if (result.status === 'ok') {
                        $scope.$emit('COMMENT_MODAL_HIDE_ALL', 'HIDE_ALL');
                        $rootScope.$broadcast('setToView', $scope.comment, $scope.id);
                        $('#jv-successMessage').show();
                        $('#jv-successMessage').text(i18n['JV_REFAPPLICATIONS_COMMENT_HAS_BEEN_SAVED']).slideDown(100).delay(4000).slideUp(100);
                    } else {
                        $scope.$emit('COMMENT_MODAL_HIDE_ALL', 'HIDE_ALL');
                    }
                });
            }
        };
    }
]);